import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export function useAccessRole() {
  const store = useStore();

  const accessRole = computed(() => store.state.accessRole);
  const accessRoleError = computed(() => store.state.accessRoleError);
  const tenant = computed(() => store.state.tenant);
  const fetchingTenant = computed(() => store.state.fetchingTenant);

  const fetchAccessRole = () => store.dispatch("fetchAccessRole");
  const fetchTenant = () => store.dispatch("fetchTenant");
  const rbacEnabled = computed(() =>
    store.getters.featureEnabledForTenant("rbac")
  );

  const canAccess = (...permissions) => {
    if (!tenant.value) return false;
    if (!rbacEnabled.value) return true;

    const role = accessRole.value;
    if (!role || !role.permissions) {
      return false;
    }
    return role.permissions.some((permission) =>
      permissions.includes(permission.key)
    );
  };

  // True once canAccess() will return stable answers: the tenant is loaded and,
  // when RBAC is on, the access-role fetch has settled (resolved OR errored).
  // Consumers whose visible tab set is gated on canAccess() use this to hold a
  // TabSwitcher non-interactive until the strip is final, so an early click can't
  // land on a tab that later shifts position as gated tabs appear.
  const accessResolved = computed(() => {
    if (!tenant.value) return false;
    if (!rbacEnabled.value) return true;
    return Boolean(accessRole.value) || Boolean(accessRoleError.value);
  });

  onMounted(() => {
    if (!tenant.value && !fetchingTenant.value) {
      fetchTenant();
    }

    fetchAccessRole().catch(() => {
      window.notify.error(
        "An error occurred when loading user permission data"
      );
    });
  });

  return {
    canAccess,
    accessResolved
  };
}
